import { Error, Input } from 'components';
import { ResetPasswordFieldNames } from 'model';
import React, { FC } from 'react';
import { Field } from 'redux-form';
import { required } from 'utils/validations';
import connect from './connect';
import { ButtonPrimary, Container, Row } from './styles';
import { Props } from './types';

const ResetPassword: FC<Props> = ({
  error,
  handleSubmit,
  invalid,
  loading,
  pristine,
}) => (
  <Container onSubmit={handleSubmit}>
    <Field
      autocomplete="current-password"
      component={Input}
      label="Password"
      name={ResetPasswordFieldNames.password}
      placeholder="Enter your new password"
      type="password"
      validate={required}
    />
    <Field
      autocomplete="current-password"
      component={Input}
      label="Repeat password"
      name={ResetPasswordFieldNames.repeatPassword}
      placeholder="Repeat your new password"
      type="password"
      validate={required}
    />
    {error && <Error text={error} />}
    <Row>
      <ButtonPrimary disabled={invalid || loading || pristine} type="submit">
        {loading ? 'Loading...' : 'Reset password'}
      </ButtonPrimary>
    </Row>
  </Container>
);

export default connect(ResetPassword);
